<template>
  <smd-one-col-layout class="view-pharmacy-orders-prescription"
                      content-styles="view-pharmacy-orders-prescription__content">
    <div :class="{'view-pharmacy-orders-prescription__inner': desktopView}">
      <div class="smd-form__section m-t-10">
        <div class="smd-form__col m-b-30">
          <text-string label-id="txt057"/>
          <smd-list-selection-panel v-if="!attachedPrescriptions.length"
                                    :has-text-string="true"
                                    @selected="showAddPrescriptionModal"
                                    @remove="removePrescriptionFn(index)">
            <text-string slot="placeholder"
                         label-id="txt059"/>
            <span class="ns-icon-ico020 ns-large-icon"
                  slot="icon">
                  <span class="path1"></span>
                  <span class="path2"></span>
              </span>
          </smd-list-selection-panel>
          <template v-else>
            <div v-for="(pres, index) in attachedPrescriptions.slice(0,1)"
                 :key="index">
              <file-pres-added-attached v-if="pres.file"
                                        :index="index"
                                        :item="pres"
                                        :get-all-listed-items="!pres.partial"
                                        @update-remarks="updateRemarks"
                                        @change-checkbox="handlePrescriptionGetAllListedItemsValue"
                                        @remove="removePrescriptionFn(index)"/>
              <file-pres-added v-else
                               :show-coupon="showPrescriptionCoupon(pres)"
                               :index="index"
                               :item="pres"
                               :get-all-listed-items="!pres.partial"
                               :remarks="pres.remarks"
                               @update-remarks="updateRemarks"
                               @change-checkbox="handlePrescriptionGetAllListedItemsValue"
                               @remove="removePrescriptionFn(index)"/>

              <div class="smd-form__col m-t-30" v-if="pres.coupons && pres.coupons.length">
                <div class="Title1 m-b-5">
                  <text-string label-id="txt1138"/>
                </div>
                <p class="Body3">
                  <text-string label-id="txt1139"/>
                </p>
                <div class="flex-row-center-x-spaced">
                  <smd-btn :variant="pres.includeOtherItems ? 'blue-enabled' : 'unselected'"
                           type="button" section="4"
                           @click="handlePrescriptionIncludeOtherItems(index, true)">
                    <text-string label-id="txt1146"/>
                  </smd-btn>
                  <smd-btn :variant="!pres.includeOtherItems ? 'blue-enabled' : 'unselected'"
                           type="button" section="4"
                           @click="handlePrescriptionIncludeOtherItems(index, false)">
                    <text-string label-id="txt1147"/>
                  </smd-btn>
                </div>
                <div v-if="pres.includeOtherItems" class="smd-checkbox__row m-t-10 m-b-15">
                  <smd-checkbox :model-value="!pres.partial"
                                :label="getElementString('txt203')"
                                @change="handlePrescriptionGetAllListedItemsValue(index, !pres.partial, '')"/>
                </div>
                <div v-if="pres.includeOtherItems && pres.partial" class="smd-form__row">
                  <smd-textarea v-model="pres.remarks"
                                :error="pres.remarks === ''"
                                :placeholder="getElementString('txt209')"/>
                </div>
              </div>

              <div class="divider--dotted m-t-30 m-b-40"></div>

              <!--    other items    -->
              <div class="smd-form__col">
                <text-string label-id="txt089"/>

                <div class="smd-form__row"
                     v-for="(item, index) in $v.orderData.$each.$iter"
                     :key="index">
                  <input :class="$isDesktop ? 'field-max-200' : 'field-max-138'"
                         type="text"
                         placeholder="ex. Paracetamol"
                         v-model.trim="item.name.$model"
                         :error="item.name.$invalid && item.quantity.$anyDirty"
                         :has-value="!item.name.$invalid"
                         @input="handleUpdatingOtherItems(index)">
                  <input :class="$isDesktop ? 'field-max-200' : 'field-max-138'"
                         type="text"
                         placeholder="10 tablets"
                         v-model.trim="item.quantity.$model"
                         :error="item.quantity.$invalid && item.name.$anyDirty"
                         :has-value="!item.quantity.$invalid"
                         @input="handleUpdatingOtherItems(index)">
                  <span class="ns-icon-ico025"
                        v-if="showRemoveOrderDataButton(index)"
                        @click="handleRemoveOtherItems(index)">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </span>
                </div>

                <div class="smd-form__row">
                  <text-string class="no-select"
                               label-id="txt118"
                               @handleClick="handleAddingOtherItems"/>
                </div>
              </div>
            </div>


            <template v-if="attachedPrescriptions.length > 1">
              <div v-for="(pres, index) in attachedPrescriptions.slice(1)"
                   :key="index + 1">
                <div class="divider--thick m-b-40" :class="{'m-t-40': index + 1 === 1}"></div>
                <div class="smd-form__col m-b-30">
                  <text-string label-id="txt057"/>
                  <file-pres-added-attached v-if="pres.file"
                                            :index="index + 1"
                                            :item="pres"
                                            :get-all-listed-items="!pres.partial"
                                            @update-remarks="updateRemarks"
                                            @change-checkbox="handlePrescriptionGetAllListedItemsValue"
                                            @remove="removePrescriptionFn(index + 1)"/>
                  <file-pres-added v-else
                                   :show-coupon="showPrescriptionCoupon(pres)"
                                   :index="index + 1"
                                   :item="pres"
                                   :get-all-listed-items="!pres.partial"
                                   :remarks="pres.remarks"
                                   @update-remarks="updateRemarks"
                                   @change-checkbox="handlePrescriptionGetAllListedItemsValue"
                                   @remove="removePrescriptionFn(index + 1)"/>

                  <div class="smd-form__col m-t-30" v-if="pres.coupons && pres.coupons.length">
                    <div class="Title1 m-b-5">
                      <text-string label-id="txt1138"/>
                    </div>
                    <p class="Body3">
                      <text-string label-id="txt1139"/>
                    </p>
                    <div class="flex-row-center-x-spaced">
                      <smd-btn :variant="pres.includeOtherItems ? 'blue-enabled' : 'unselected'"
                               type="button" section="4"
                               @click="handlePrescriptionIncludeOtherItems(index + 1, true)">
                        <text-string label-id="txt1146"/>
                      </smd-btn>
                      <smd-btn :variant="!pres.includeOtherItems ? 'blue-enabled' : 'unselected'"
                               type="button" section="4"
                               @click="handlePrescriptionIncludeOtherItems(index + 1, false)">
                        <text-string label-id="txt1147"/>
                      </smd-btn>
                    </div>
                    <div v-if="pres.includeOtherItems" class="smd-checkbox__row m-t-10 m-b-15">
                      <smd-checkbox :model-value="!pres.partial"
                                    :label="getElementString('txt203')"
                                    @change="handlePrescriptionGetAllListedItemsValue(index + 1, !pres.partial, '')"/>
                    </div>
                    <div v-if="pres.includeOtherItems && pres.partial" class="smd-form__row">
                      <smd-textarea v-model="pres.remarks"
                                    :error="pres.remarks === ''"
                                    :placeholder="getElementString('txt209')"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>

      <smd-list-selection-panel v-if="attachedPrescriptions.length"
                                :has-text-string="true"
                                @selected="showAddPrescriptionModal">
        <text-string slot="placeholder"
                     class="dodgerBlue"
                     label-id="txt087"/>
        <span class="ns-icon-ico019 ns-large-icon" slot="icon">
              <span class="path1 dodgerBlue"></span>
              <span class="path2 dodgerBlue"></span>
              <span class="path3 dodgerBlue"></span>
        </span>
      </smd-list-selection-panel>


      <div class="view-pharmacy-orders-prescription__footer-btn m-t-75"
           v-if="desktopView">
        <smd-btn class="no-select"
                 section="1"
                 :variant="computedContinueBtnVariant"
                 :disabled="isContinueBtnDisabled"
                 @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
          <text-string label-id="txt099"/>
        </smd-btn>
      </div>
    </div>

    <div slot="bottom-nav"
         v-if="!desktopView">
      <smd-btn class="no-select"
               section="1"
               :variant="computedContinueBtnVariant"
               :disabled="isContinueBtnDisabled"
               @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
        <text-string label-id="txt100"/>
      </smd-btn>
    </div>

    <!--  hidden input for adding id  -->
    <input class="input-hidden"
           ref="id-input"
           type="file"
           @change="handleIdFileSelection"/>
  </smd-one-col-layout>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from "vuex";
  import {mapFields} from 'vuex-map-fields';
  import {required} from 'vuelidate/lib/validators';
  import debounce from 'lodash/debounce';

  import FilePresAdded from '@/components/file/file-pres-added';
  import FilePresAddedAttached from '@/components/file/file-pres-added-attached';
  import FormValidationMixin from '@/mixins/form-validations';
  import GetElementString from '@/mixins/get-element-string';
  import ModalPreviewFile from '../../../modals/modal-preview-file';
  import SetActiveStepMixin from '@/mixins/set-active-step-mixin';

  import {PHARMACY_ORDERS_DISCOUNT} from '@/reference/pharmacy-order-steps'

  import {
    ACTION_UPDATE_PHARMACY_ORDER, GETTER_FILES, MUTATE_ADD_ORDER_DATA_ITEM,
    MUTATE_REMOVE_ATTACHED_ID,
    MUTATE_REMOVE_ATTACHED_PRESCRIPTION, MUTATE_REMOVE_ORDER_DATA_ITEM,
    MUTATE_UPDATE_ATTACHED_PRESCRIPTION_REMARKS, MUTATE_UPDATE_ORDER_DATA_ITEM,
    MUTATE_ORDER_ATTACHED_PRESCRIPTION_INCLUDE_OTHER_ITEMS,
  } from '@/store/types'
  import Routes from "@/router/routes";
  import {Reference} from "smd-vue-scaffold";
  import {
    isCouponExpired,
    canAvailCoupon,
    getPrescriptionCoupon,
  } from "@/utils/medicine";

  export default {
    name: "view-pharmacy-orders-prescription",
    components: {
      FilePresAdded,
      FilePresAddedAttached,
    },
    mixins: [
      FormValidationMixin,
      GetElementString,
      SetActiveStepMixin
    ],
    props: {
      desktopView: {type: Boolean, default: false}
    },
    data() {
      return {
        getAllListedItems: true,
      }
    },
    computed: {
      ...mapFields({
        attachedIds: 'attachedIds',
        attachedPrescriptions: 'attachedPrescriptions',
        idFileView: 'idFileView',
        orderData: 'orderData',
        prescriptionFileView: 'prescriptionFileView',
      }),
      ...mapGetters({
        files: GETTER_FILES,
      }),
      isEmptyOrder() {
        const hasAdditionalItems = !!this.orderData.find((item) => Object.values(item).join('') !== '');

        return !hasAdditionalItems && !this.attachedPrescriptions.length;
      },
      computedContinueBtnVariant() {
        return this.isEmptyOrder ||
        this.isPartialAndHasNoRemarks ||
        this.$v.$anyDirty &&
        this.$v.$invalid ?
          'disabled' : 'enable-blue'
      },
      isContinueBtnDisabled() {
        return this.isEmptyOrder ||
          this.isPartialAndHasNoRemarks ||
          this.$v.$anyDirty &&
          this.$v.$invalid;
      },
      isPartialAndHasNoRemarks() {
        return this.attachedPrescriptions.some(ap => {
          return ap.partial === true && ap.remarks === '';
        })
      },
    },
    methods: {
      ...mapActions({
        updateOrder: ACTION_UPDATE_PHARMACY_ORDER,
      }),
      ...mapMutations({
        addOrderDataItem: MUTATE_ADD_ORDER_DATA_ITEM,
        removeAttachedId: MUTATE_REMOVE_ATTACHED_ID,
        removeAttachedPrescription: MUTATE_REMOVE_ATTACHED_PRESCRIPTION,
        removeOrderDataItem: MUTATE_REMOVE_ORDER_DATA_ITEM,
        updateAttachedPrescriptionRemarks: MUTATE_UPDATE_ATTACHED_PRESCRIPTION_REMARKS,
        updateAttachedPrescriptionIncludeOtherItems: MUTATE_ORDER_ATTACHED_PRESCRIPTION_INCLUDE_OTHER_ITEMS,
        updateOrderDataItem: MUTATE_UPDATE_ORDER_DATA_ITEM
      }),
      addAttachedIdFile() {
        this.$refs['id-input'].click();
      },
      changeId() {
        this.$refs['id-input'].click();
      },
      handleAddingOtherItems: debounce(function () {
        this.addOrderDataItem();
      }, 450),
      handleIdFileSelection() {
        const [file] = this.$refs['id-input'].files;

        // some WebViews fire change with an empty FileList on cancel; the preview
        // modal reads file.type, so opening it without a file throws
        if (!file) {
          return;
        }

        this.idFileView = file;

        this.previewFile(this.idFileView);
        this.$nextTick(() => {
          this.$refs['id-input'].value = '';
        })
      },
      handlePrescriptionIncludeOtherItems(index, includeOtherItems) {
        this.updateAttachedPrescriptionIncludeOtherItems({
          index,
          includeOtherItems,
        });
      },
      handlePrescriptionGetAllListedItemsValue(index, partial, remarks) {
        this.updateAttachedPrescriptionRemarks({
          index: index,
          partial: partial,
          remarks: remarks
        })
      },
      handleRemoveOtherItems(index) {
        this.removeOrderDataItem(index)
        if (!this.orderData.length) {
          this.addOrderDataItem();
          this.$v.$reset();
        }
      },
      handleUpdatingOtherItems(index) {
        if (this.orderData[index].name === '' && this.orderData[index].quantity === '') {
          this.$v.$reset();
        } else if (this.orderData[index].name !== '' && this.orderData[index].quantity !== '') {
          this.$v.$reset();
        }
      },
      openModalAddPrescription() {
        this.$router.push({
          name: Routes.PHARMACY_ORDERS_ADD_PRESCRIPTION
        })
      },
      previewFile(file) {
        this.$modal.open({
          component: ModalPreviewFile,
          size: Reference.SmdModalSizes.xs,
          position: !this.$isMobile ? 'auto-height detached' : '',
          props: {
            file: [file],
            title: this.getElementString('txt111')
          }
        })
      },
      removeAttachedIdFileFn(index) {
        this.removeAttachedId(index);
      },
      removePrescriptionFn(index) {
        this.removeAttachedPrescription(index);
      },
      showAddPrescriptionModal() {
        this.openModalAddPrescription();
      },
      showRemoveOrderDataButton(index) {
        if (index > 0 || this.orderData[index].name !== '' || this.orderData[index].quantity !== '') {
          return true
        }
      },
      updateRemarks(index, partial, remarks) {
        this.updateAttachedPrescriptionRemarks({
          index: index,
          partial: partial,
          remarks: remarks
        })
      },
      showPrescriptionCoupon(prescription) {
        const coupon = getPrescriptionCoupon(prescription);

        if (coupon) {
          return canAvailCoupon(coupon) && !isCouponExpired(coupon);
        }

        return false;
      },
    },
    validations: {
      orderData: {
        $each: {
          name: {
            required
          },
          quantity: {
            required
          }
        }
      }
    },
    created() {
      if (this.attachedPrescriptions.length === 0 && this.$route.name !== Routes.PHARMACY_ORDERS) {
        this.$router.push({
          name: Routes.PHARMACY_ORDERS
        })
      }
    },
    PHARMACY_ORDERS_DISCOUNT,
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .view-pharmacy-orders-prescription {
    [class*='ns-icon-'] .dodgerBlue:not(.path2):before {
      color: color(dodgerBlue) !important;
    }

    //hot fix for btn unselected text color
    .btn004--unselected .white {
      color: color(gray-900) !important;
    }
  }

  .view-pharmacy-orders-prescription__inner {
    @include box-shadow();
    @include border-radius();
    background: color(white);
    padding: space(base) space(xxxl) 0;
    position: relative;
    max-width: 900px;
    margin-right: space(xxl);

    @include responsive('max-width: 1023px') {
      margin-right: 0;
    }
    @include responsive('min-width: 1800px') {
      margin: 0 auto;
    }
  }

  .view-pharmacy-orders-prescription__content {
    padding-bottom: space(xxl) !important;
    padding-top: space(xl) !important;
  }

  .view-pharmacy-orders-prescription__footer-btn {
    margin-left: -60px;
    margin-right: -60px;

    button {
      border-radius: 0 0 10px 10px;
    }
  }
</style>
